var get                 = require("object-path").get,
    transformAncestor,
    transformMediaLinks = require("app/Domain/Ott/Api/V2/DataTransformers/transformMediaLinks");

/**
 * Adds links to media item.
 *
 * @param    {string}   language         The current application language
 * @param    {Object}   media            The media item data
 * @param    {Object=}  playlistDetails  The playlist details, if supplied
 * @returns  {Object}   The transformed data
 * @public
 */
exports.transformMedia = function(language, media, playlistDetails) {
    // Add links
    media = transformMediaLinks(language, media, playlistDetails);

    if (media.parent && typeof media.parent === "object") {
        media.parent = transformAncestor(language, media.parent);
    }

    return media;
};

/**
 * Adds links to ancestor.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  media     The media data
 * @returns  {Object}  The transformed data
 * @public
 */
transformAncestor = function(language, media) {
    media = transformMediaLinks(language, media);

    if (media.parent && typeof media.parent === "object") {
        media.parent = transformAncestor(language, media.parent);
    }

    return media;
};

/**
 * Stub, for the moment it appears we don't need anything yet.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  category  The category data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformCategory = function(language, category) {
    return transformMediaLinks(language, category);
};

/**
 * Make watchingSession data easier to work with.
 *
 * @param    {string}  language         The current application language
 * @param    {string}  mediaType        The type of the media item for which a
 *                                      session has been returned
 * @param    {Object}  watchingSession  The watching session data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformWatchingSession = function(language, mediaType, watchingSession) {
    var urlsByType = {},
        i,
        length;

    watchingSession = watchingSession || {};

    // Reader content needs some tweaking
    if (Array.isArray(watchingSession.urls)
        && (mediaType === "book"
            || mediaType === "issue"
        )) {
        // Index urls by type
        urlsByType.lq        = watchingSession.urls.find(function(set) {
            return get(set, "type", null) === "lq";
        });
        urlsByType.mq        = watchingSession.urls.find(function(set) {
            return get(set, "type", null) === "mq";
        });
        urlsByType.hq        = watchingSession.urls.find(function(set) {
            return get(set, "type", null) === "hq";
        });
        watchingSession.urls = urlsByType;

        // Get length
        length                 = get(watchingSession, "urls.lq.path.length", 0);
        watchingSession.length = length;

        // Add indexes to pages and turn dimensions into numbers
        for (i = 0; i < length; i++) {
            watchingSession.urls.lq.path[i].id     = i;
            watchingSession.urls.lq.path[i].width  = parseInt(watchingSession.urls.lq.path[i].width, 10);
            watchingSession.urls.lq.path[i].height = parseInt(watchingSession.urls.lq.path[i].height, 10);

            watchingSession.urls.mq.path[i].id     = i;
            watchingSession.urls.mq.path[i].width  = parseInt(watchingSession.urls.mq.path[i].width, 10);
            watchingSession.urls.mq.path[i].height = parseInt(watchingSession.urls.mq.path[i].height, 10);

            watchingSession.urls.hq.path[i].id     = i;
            watchingSession.urls.hq.path[i].width  = parseInt(watchingSession.urls.hq.path[i].width, 10);
            watchingSession.urls.hq.path[i].height = parseInt(watchingSession.urls.hq.path[i].height, 10);
        }
    }

    // Reader content needs some tweaking
    if (watchingSession.urls && mediaType === "photo") {
        watchingSession.urls.forEach(function(set) {
            urlsByType[set.type] = {
                width:  parseInt(set.path[0].width, 10),
                height: parseInt(set.path[0].height, 10),
                url:    set.path[0].url
            };
        });
        watchingSession.urls = urlsByType;
    }

    return watchingSession;
};

/**
 * This method is here for consistency, so we have something in place in case we
 * need to modify the data returned by the API.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  offer     The offer data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformOffer = function(language, offer) {
    return offer;
};

/**
 * Adds the private asset data contained in the `sessionData` to the primary
 * asset in `mediaData`.
 *
 * @param    {Object}  mediaData    The mediaData as transformed by the
 *                                  `transformMedia` method.
 * @param    {Object}  sessionData  The sessionData as transformed by the
 *                                  `transformWatchingSession` method.
 * @returns  {Object}  The transformed data
 * @public
 */
exports.addSessionDataToAsset = function(mediaData, sessionData) {
    if (mediaData.type === "photo") {
        mediaData.assets.map(function(asset) {
            if (asset.type === "primary") {
                asset.width  = sessionData.urls.hq.width;
                asset.height = sessionData.urls.hq.height;
                asset.url    = sessionData.urls.hq.url;
            }

            return asset;
        });
    }

    return mediaData;
};
